import { useTracking } from 'react-tracking';

import { Heading, Text, useMount } from '@simplywallst/ui-core';

import { PortfolioIllustration } from '@/components/PortfolioLinking';

import { Section, TextWrapper } from './styled';

const ErrorState = () => {
  const { Track, trackEvent } = useTracking({
    type: 'track',
    modifier: 'errorState',
  });

  useMount(() => {
    trackEvent({ action: 'landed' });
  });

  return (
    <Track>
      <Section
        as="section"
        data-cy-id="error-state"
        templateRows="auto auto"
        placeItems="center"
        gap="16px"
      >
        <PortfolioIllustration />
        <TextWrapper>
          <Heading as="h3" typography="smallStrong" textAlign="center">
            Something went wrong!
          </Heading>
          <Text typography="xSmall" color="mediumGray" textAlign="center">
            We're sorry, but an error occurred. Please try again later.
          </Text>
        </TextWrapper>
      </Section>
    </Track>
  );
};

export default ErrorState;
